import { User } from './user';

export class LoggedInUser extends User {
  userId: number;
  photoMediaId: any;
  profileId: any;
  emailAddress: any;
  fullName: any;
  systemAdmin: any;
  organizationAdmin: any;
  organizationLogo: any;
  brandingInfo: any;
  canGetDemographics: any;
  organizationType: any;
  canPullReports: any;
}



// WEBPACK FOOTER //
// ./src/app/classes/logged-in-user.ts